import { readValueByName } from '../field-paths';
import { expandSlugArraysInObject, isOptionSetsLookup } from '../options-resolver';

const resolveProcessorPath = (path, formValues, context) => {
  if (!path || typeof path !== 'string') return undefined;
  return readValueByName({ ...context, ...formValues }, path);
};

export const resolveConfigurationArrayEntry = (formValues, context, params = {}, field = null) => {
  const arrayPath = params.array_path || params.arrayPath;
  const matchField = params.match_field || params.matchField;
  const matchFrom = params.match_from || params.matchFrom || params.match_from_field;

  if (!arrayPath || !matchField || !matchFrom) return {};

  const array = resolveProcessorPath(arrayPath, formValues, context);
  if (!Array.isArray(array)) return {};

  const matchValue =
    formValues?.[matchFrom] ?? resolveProcessorPath(matchFrom, formValues, context);
  if (matchValue == null || matchValue === '') return {};

  const entry = array.find(item => item?.[matchField] === matchValue) ?? {};
  const optionSets = field?.optionSets ?? field?.option_sets;
  if (!isOptionSetsLookup(optionSets)) return entry;

  return expandSlugArraysInObject(entry, optionSets, Object.keys(optionSets));
};

export const resolveOptionSetItemName = (formValues, context, params = {}, field = null) => {
  const matchFrom = params.match_from || params.matchFrom;
  const optionSet = params.option_set || params.optionSet;
  if (!matchFrom || !optionSet) return '';

  const fromContext = context?.[matchFrom];
  if (
    fromContext &&
    typeof fromContext === 'object' &&
    fromContext.name != null &&
    fromContext.name !== ''
  ) {
    return fromContext.name;
  }

  const slug =
    (typeof fromContext === 'string' ? fromContext : null) ??
    formValues?.[matchFrom] ??
    resolveProcessorPath(matchFrom, formValues, context);
  if (slug == null || slug === '') return '';

  const optionSets = field?.optionSets ?? field?.option_sets;
  const set = isOptionSetsLookup(optionSets) ? optionSets[optionSet] : null;
  if (!set || typeof set !== 'object') return '';

  const row = set[slug] ?? Object.values(set).find(entry => entry?.value === slug);
  return row?.name ?? '';
};

export const resolveAuCriminalCheckProvider = (formValues, context) => {
  const enabled = context?.enabled_company_checks || {};
  const hasAcic = !!enabled.acic_check;
  const hasAfp = !!enabled.afp;
  if (hasAcic && !hasAfp) return 'acic_check';
  if (hasAfp && !hasAcic) return 'afp';
  const selected = formValues?.au_criminal_check_provider;
  if (selected === 'acic_check' || selected === 'afp') return selected;
  return 'afp';
};

export const CONFIG_PROCESSORS = {
  resolveConfigurationArrayEntry,
  resolveOptionSetItemName,
  resolveAuCriminalCheckProvider,
};

export default CONFIG_PROCESSORS;
